import SessionEvent from 'session/SessionEvent.js';
import Tone from 'tone';
import {TRACK_REVERSE} from 'session/constants.js';

class TrackReverseEvent extends SessionEvent {
    constructor(track, reverse) {
        super();
        this.track= track;
        this.reverse = reverse;
    }

    isSkippable() {
        return false;
    }

    executeEvent(sequencerEngine) {
        this.subSequence.tracks[this.track.trackNumber].reverse(this.reverse, true);
    }

    getType() {
        return TRACK_REVERSE;
    }

    getJson() {
        return { ... super.getJson(),
            trackNumber: this.track.trackNumber,
            reverse: this.reverse
        };
    }

    fromJson(json, sequencerEngine) {
        super.fromJson(json);
        this.track = sequencerEngine.tracks[json.trackNumber];
        this.reverse = json.reverse;
        return this;
    }
}

export default TrackReverseEvent;
